module.exports = __webpack_public_path__ + "static/media/before-sandy.4ee72c13.jpg";